module.exports = __webpack_public_path__ + "static/media/hazelnut.fbb04b3d.JPG";